import { Box, Button } from '@mui/material';
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import Layout from './Layout';
import AuthHead from './authhead';
import { BtnInput, EmailInput } from './inputs';
import { ArrowBack } from '@mui/icons-material';

export default function Resetpassword() {
    const {classes}=styles();
  return (
    <Layout image='/images/explore/explore.svg'>
 <Box className={`${classes.container}`}>
 <AuthHead action="Reset Password" description='Enter your email to reset your password'/>
 <Box className={classes.input}>
 <EmailInput/> 
 <BtnInput name={'Continue'}/>
 <Button startIcon={<ArrowBack/>}>
 Go back to the log in page
 </Button>
 </Box>
 </Box>
    </Layout>
   
  )
}

const styles=makeStyles()((theme)=>({
    container:{
      backgroundColor:theme.colors.white,
      display:'flex',
      flexDirection:'column',
     width:'80%',
     gap:theme.spacing(3) 
    },
    debug:{
        border:'1px solid green'
    },
    input:{
      display:'flex',
      flexDirection:'column',
      gap:theme.spacing(3) 
    }
}))